class ArtistBio extends HTMLElement {
  constructor() {
    super();
    console.log(this);

    this.excerpt = this.querySelector('[data-excerpt]');
    this.full = this.querySelector('[data-full]');
    this.moreButton = this.querySelector('[data-more]');
    this.lessButton = this.querySelector('[data-less]');

    this.classes = {
      hide: 'tw-hidden'
    }

    this.moreButton.addEventListener('click', this.revealFull.bind(this));
    this.lessButton.addEventListener('click', this.hideFull.bind(this));
  }

  revealFull(e) {
    e.preventDefault();
    this.excerpt.classList.add(this.classes.hide);
    this.full.classList.remove(this.classes.hide);
  }

  hideFull(e) {
    e.preventDefault();
    this.excerpt.classList.remove(this.classes.hide);
    this.full.classList.add(this.classes.hide);
  }

}

customElements.define('artist-bio', ArtistBio);
